import { usePlayersStore } from "@/stores";
export function updatePlayerName([index, value]: [number, string]) {
  const playersStore = usePlayersStore();
  const player = playersStore.players[index];
  if (!player) return;

  playersStore.update({
    player,
    property: "name",
    value,
    isFromSocket: true,
  });
}
